<template>
<div class="online-paydetail paydetail">
  <div class="nav-bar">
    <i
      @click="goDepositHandle"
      class="el-icon-back icon-btn pointer"></i>
    <span
      @click="goDepositHandle"
      class="pointer">{{currentChannel.channelName}}</span>
  </div>
  <div class="pay-detail">
    <div class="tips-card">
      <div class="subtitle">{{$t('Precautions')}}</div>
      <p class="tips-p"
        v-for="(item,index) in tips"
        :key="index"
      >{{item}}</p>
    </div>
    <div class="content-card" >
      <div class="account-list-top-text">{{$t('deposit_account')}}</div>
      <mtaccount-list
        ref="mtlist"
      ></mtaccount-list>

      <div class="nav-title">{{$t('Payment_currency')}}</div>
      <div
        class="tab-inner">
        <div class="tab-item"
             v-for="(item,index) in currencyList"
             :key="index"
             :class="{on: item == currency }"
             :style="getActiveStyle(item)"
             @click="currencyHandle(item)"
        >
          {{item}}
        </div>
      </div>
      <div class="payee-info">
        <div class="h5">{{$t('Billing_message')}}</div>
        <div class="gray-bgc-box">
          <div class="info-line key-data-line">
            <span class="left-span">{{$t('Bank_name')}}</span>
            <span class="middle-span">{{currentChannel.BankName}}</span>
          </div>
          <div class="info-line">
            <span class="left-span">{{$t('Bank_address')}}</span>
            <span class="middle-span">{{currentChannel.BankAddress}}</span>
          </div>
          <div class="info-line">
            <span class="left-span">SWIFT</span>
            <span class="middle-span">{{currentChannel.SWIFTCODE}}</span>
          </div>
          <div class="info-line">
            <span class="left-span">{{$t('Payee_account')}}</span>
            <span class="middle-span">{{currentChannel.BankNumberAccount || '-'}}</span>
          </div>
          <div class="info-line">
            <span class="left-span">{{$t('Payee_Address')}}</span>
            <span class="middle-span">{{currentChannel.AccountName}}</span>
          </div>
          <div class="info-line">
            <span class="left-span">{{$t('remark')}}</span>
            <span class="middle-span">{{'-'}}</span>
          </div>
        </div>
      </div>
      <el-row>
        <el-col
          :lg="8"
          :sm="8"
          :xs="24"
        >
          <el-form
            class="elform"
            ref="form"
            :model="form"
            :rules="rules"
            label-position="top"
          >
            <el-form-item
              :label="$t('Amount_deposited')"
              prop="amount"
              class="has-prefix-item"
            >
              <el-input
                :placeholder="amountTips"
                :value="form.curentLimitMoney"
                @blur="curentMoneyBlurHandle"
                @input="inputHandle"
              >
                <span slot="prefix">USD</span>
              </el-input>
              <p>{{$t('User.fee')}}: ${{fee}}</p>
            </el-form-item>
            <el-form-item
              :label="$t('Trade.payMoney')"
              class="has-prefix-item"
            >
              <el-input
                disabled
                :value="getTotalSum"
              >
                <span slot="prefix">{{currency}}</span>
              </el-input>
            </el-form-item>
            <el-form-item
              :label="$t('payment_voucher')"
              prop="voucherImgUrl"
            >
              <upload-img-tips></upload-img-tips>
              <div>
                <MobileImageUpload
                  :value="form.voucherImgUrl"
                  @input="(url) => { form.voucherImgUrl = url }"
                  @success="(url) => { form.voucherImgUrl = url }"
                >
                  <img v-if="form.voucherImgUrl" :src="form.voucherImgUrl" class="avatar">
                  <div v-else class="avatar-uploader-btn">
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                  </div>
                </MobileImageUpload>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                :loading="submitLoading"
                @click="payHandle"
              >{{$t('confirm_payment')}}</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>
  </div>
</div>
</template>

<script>
import mtaccountList from "@/components/public/mtaccountList";
import { colorRgba } from "@/utils";
import {
  EnterMoeny,
  getUSDExRateAndFee
} from '@/api/userCenter.js';
import { mapGetters } from 'vuex'
import {amountInputValidate, onlyTwoBitFloat} from "@/utils/validate";
export default {
  name: "index",
  components: {
    mtaccountList
  },
  data() {
    let _this = this;
    var validateMoney = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('payChannel.inputMoney')));
      }else {
        if(!onlyTwoBitFloat(value)){
          callback(new Error(this.$t('User.onlyInputTwoBitNumber')));
          this.$emit('request-err');
          return;
        }else {
          callback();
        }
      }
    };



    return {
      // 提示后台获取 todo
      tips: [
        '到账时间 : 2-5 个工作日',
        '支持汇款的货币 : 所有币种',
        '单笔支付限额 : USD 100 - 500,000',
      ],
      currency: 'USD',

      // 表单
      form: {
        curentLimitMoney: '',
        voucherImgUrl: '',
      },
      rules: {
        curentLimitMoney: [
          { required: true, message: _this.$t('please_input'), trigger: 'blur' },
          { validator: validateMoney, trigger: 'blur' },
        ],
        voucherImgUrl:[
          { required: true, message: _this.$t('Please_upload_payment_voucher'), trigger: 'change' },
        ],
      },
      currentChannel: {
        minimumLimit: '',
        currency: '',
        qrPic: '',
        address: '',
      },
      exchangeRate: '',
      submitLoading: false,
    }
  },
  computed: {
    ...mapGetters(['userInfo','realMobile','themeColor']),
    currencyList(){
      return ['USD'];
    },
    // 没算手续费的总额,
    getTotalSum(){
      if(this.form.curentLimitMoney == '' || !Number(this.form.curentLimitMoney)){
        return `0`;
      }
      // 固定USD
      return  this.form.curentLimitMoney + this.fee;
    },
    amountTips(){
      let minLimit = '';

      minLimit = this.currentChannel.minimumLimit;
      return `≥${minLimit}`
    },
    //手续费
    fee(){
      // 保留两位小数
      if(!this.currentChannel.feeValue){
        return 0;
      }
      let feeTotal = (this.currentChannel.feeValue * this.form.curentLimitMoney).toFixed(2);
      return feeTotal;
    },
    rate(){
      return this.currentChannel.nominalExRateDeposit;
    },

  },
  created(){
    this.getChannelList();
  },
  mounted(){
    let reouterview = document.getElementById('routerview');
    reouterview.classList.add('no-padding-import');
  },
  beforeDestroy(){
    let reouterview = document.getElementById('routerview');
    reouterview && reouterview.classList.remove('no-padding-import');
  },
  methods: {
    getChannelList(){
      getUSDExRateAndFee({
        oprType: 1,
        payType:2,
      }).then((res) => {
        if(res.data.length){
          for (let i = 0; i < res.data.length; i++) {
            if(res.data[i].channelCode == this.$route.params.channelCode){
              this.currentChannel = res.data[i];
              break;
            }
          }
        }
      })
    },
    inputHandle(val){
      this.form.curentLimitMoney = amountInputValidate(val);
    },
    curentMoneyBlurHandle(){

    },
    getLabel(item){
      return `'MT4' (${item.login}) ${this.$t('balance')}: ${item.balance}`
    },
    getActiveStyle(item){
      if(item == this.currency){
        return {
          backgroundColor: colorRgba(this.themeColor,0.1),
        }
      }
    },
    currencyHandle(item){
      this.currency = item;
    },
    payHandle(item){

      this.$refs.form.validate((valid) => {
        if(valid){
          this.enterGolden();
        }else {
          console.log('no-pass');
        }
      })
    },
    enterGolden(){
      let  selfCurrentMt4Info = this.$refs.mtlist.currentMt4Info;
      if(!selfCurrentMt4Info.login){
        return;
      }
      let parmas = {
        custId: this.userInfo.id,
        serverId: selfCurrentMt4Info.serverId,
        login: selfCurrentMt4Info.login,
        group: selfCurrentMt4Info.group,
        amount: this.form.curentLimitMoney,
        billAmount: this.form.curentLimitMoney + "",
        currency:  'USD',
        payType: this.currentChannel.channelCode,
        realExRate: this.currentChannel.realExRateDeposit,
        nominalExRate: this.currentChannel.nominalExRateDeposit,
        type: 1,
        // 支付凭证
        payPic: this.form.voucherImgUrl,
      };
      this.submitLoading = true;
      EnterMoeny(parmas).then((res) => {
        this.$router.push({name: 'successSubmit'}).catch(() => {
          window.location.href = this.$router.resolve({name: 'successSubmit'}).href;
        });
      }).catch((err) => {
        this.submitLoading = false;
        this.$emit('request-err')
      })
    },
    goDepositHandle(){
      this.$router.go(-1);
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/variable";
.online-paydetail {
  .nav-bar {

    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 20px;
    .icon-btn {
      font-size: 16px;
    }
  }

  .payee-info {
    .h5 {
      margin-bottom: 15px;
    }
    .gray-bgc-box {
      background-color: #F8F8F8;
      padding: 20px 0;
      margin-bottom: 20px;
    }
    .info-line {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      margin-left: 20px;
      margin-bottom: 15px;
      .copy-btn {
        margin-left: 20px;
        cursor: pointer;
        color: #B9B9C3;
      }

      .key-data-line {
        .middle-span {
          color: #5E5873;
        }
      }

      .qrimg {
        width: 80px;
        height: 80px;
      }
      .left-span {
        padding-right: 20px;
        color: #A29FAE;
        text-align: left;
      }
    }
  }

  .pay-detail {
    padding: 24px;
    .tips-card,
    .content-card {
      background-color: #ffffff;
      border-radius: 10px;
      margin-bottom: 24px;
      padding: 24px;
      .elform {
        .has-prefix-item {
          /deep/ .el-input__inner {
            padding-left: 60px;
          }
          /deep/ .el-input__prefix {
            left: 16px
          }
        }

      }
    }

    .tips-card {
      .tips-p {
        color: #5E5873;
      }
    }
    .account-inner {
      border: 1px solid #EBE9F1;
      border-radius: 5px;
      padding: 10px;
      cursor: pointer;
      &.active {
        border-color: $themeColor;
      }
      .account-top {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .login {
          padding-left: 10px;
          font-size: 14px;
          font-weight: 600;
          color: #6E6B7B;
        }
      }

      .inner-bot {
        padding-left: 30px;
        margin-top: 5px;
      }
      .small-icon {
        width: 24px;
        height: 24px;
      }
    }

    .nav-title {
      margin-top: 30px;
      margin-bottom: 15px;
    }
  }
  .mobile-row {
    .el-dropdown,
    .account-inner {
      width: 100%;
    }
  }
}
</style>
